// extracted by mini-css-extract-plugin
export var addButton = "_dg-4";
export var contentBlockImage = "_dg-i";
export var contentBlockWidgetPreview = "_dg-g";
export var fulfillmentCutoffWidgetPreview = "_dg-9";
export var imageBackdrop = "_dg-6";
export var imageIcon = "_dg-8";
export var lowProfileImageContainer = "_dg-b";
export var lowProfileImageIcon = "_dg-f";
export var lowProfileImageIconContainer = "_dg-e";
export var lowProfileImagePlaceholder = "_dg-d";
export var lowProfileProductImage = "_dg-c";
export var lowProfileProductUpsellWidgetPreview = "_dg-a";
export var productCard = "_dg-5";
export var productImage = "_dg-7";
export var productReviewsWidgetPreview = "_dg-h";
export var progressBar = "_dg-1";
export var progressBarFill = "_dg-2";
export var progressBarTrack = "_dg-3";
export var shippingOptionWidgetPreview = "_dg-j";
export var shippingUpsellProgressBar = "_dg-k";
export var thresholdUpsellWidgetPreview = "_dg-0";